/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderStatsDto } from '../../models/shop-order-stats-dto';

export interface ShopOrderAdminControllerGetStatsV1$Params {
}

export function shopOrderAdminControllerGetStatsV1(http: HttpClient, rootUrl: string, params?: ShopOrderAdminControllerGetStatsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderStatsDto>> {
  const rb = new RequestBuilder(rootUrl, shopOrderAdminControllerGetStatsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderStatsDto>;
    })
  );
}

shopOrderAdminControllerGetStatsV1.PATH = '/api/v1/shop-orders/admin/stats';
